/**
 * @generated SignedSource<<eba08b540e4d2a7a8ce72ab2a77c7332>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type productSidePanelContent_RemoveAIVirtualModelMutation$variables = {
  productIds: ReadonlyArray<number>;
  ruleId: string;
};
export type productSidePanelContent_RemoveAIVirtualModelMutation$data = {
  readonly removeProductsFromAIVirtualModelRule: {
    readonly result: boolean;
  };
};
export type productSidePanelContent_RemoveAIVirtualModelMutation = {
  response: productSidePanelContent_RemoveAIVirtualModelMutation$data;
  variables: productSidePanelContent_RemoveAIVirtualModelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productIds",
        "variableName": "productIds"
      },
      {
        "kind": "Variable",
        "name": "ruleId",
        "variableName": "ruleId"
      }
    ],
    "concreteType": "ProductAssignmentResult",
    "kind": "LinkedField",
    "name": "removeProductsFromAIVirtualModelRule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "productSidePanelContent_RemoveAIVirtualModelMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "productSidePanelContent_RemoveAIVirtualModelMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d54c87946f647ef0a89506e7e4782110",
    "id": null,
    "metadata": {},
    "name": "productSidePanelContent_RemoveAIVirtualModelMutation",
    "operationKind": "mutation",
    "text": "mutation productSidePanelContent_RemoveAIVirtualModelMutation(\n  $ruleId: ID!\n  $productIds: [Long!]!\n) {\n  removeProductsFromAIVirtualModelRule(ruleId: $ruleId, productIds: $productIds) {\n    result\n  }\n}\n"
  }
};
})();

(node as any).hash = "00a417f572c5cb010a60891e8cbacb67";

export default node;
